<template>
    <div id="formContainer" :class="surveyTitle"> 
        
        <div v-if="survey" id="surveyContainer" ref="surveySlider">
            <survey :survey="survey" :class="pageClass"></survey>
            <component :is="pageComponent" :content="pageContent" v-model="pageValues"></component>
            <keyboard v-if="showKeyboard" :class="{'numpad':keyboardIsNumpad}" @delete="backspace" @input="typed" :layouts="keyboardKeys"></keyboard>
        </div>
        
    </div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import {Survey} from 'survey-vue'
import Keyboard from 'vue-keyboard'

// COMPONENTS
import VerticalSlider from '../components/VerticalSlider'
import HorizontalSlider from '../components/HorizontalSlider'
import ValuesExplorer from '../components/ValuesExplorer'
import EnergySlider from '../components/EnergySlider'
import Breathing from '../components/Breathing'
import Scan from '../components/Scan'
import BiometricsReport from '../components/BiometricsReport'

export default {
    name: 'FormPage',
    props: {},
    mixins: [],
    data() {
        let startTime = new Date()
        return {
            introSelection: null,
            devMode: false,
            devSkipToSurvey: "Biometrics",
            devSkipToPage: "pBreathingYesNo",
            survey: null,
            rebooted: false,
            pageClass: null,
            pageValues: null,
            pageContent: null,
            pageComponent: null,
            useAnimation: true,
            isCrossfaded: false,
            keyboardTarget: null,
            showKeyboard: false,
            keyboardIsNumpad: false,
            pageNeedsMods: true,
            leds: false,
            timestamp: startTime,
            timelog: {}
        }
    },

    components: {
        Survey,
        VerticalSlider,
        HorizontalSlider,
        ValuesExplorer,
        EnergySlider,
        Breathing,
        Scan,
        BiometricsReport,
        Keyboard
    },

    methods: {
        getElapsedTime() {
            let endTime = new Date()
            let timeDiff = endTime - this.timestamp; //in ms
            timeDiff /= 1000
            var seconds = Math.round(timeDiff)
            return seconds
        },
        getSurvey(title) {
            this.rebooted = false
            this.$getSurvey(title).then((newSurveyData) => {
                // let newSurveyData = this.$getSurvey(title)
                let model = newSurveyData.survey
                // Animation on LED
                if (newSurveyData.ledColor == '#FFFFFF') {
                    this.$animateLEDS("passive", "#000000")
                } else {
                    this.$animateLEDS("sweep", newSurveyData.ledColor)
                }
                
                // Setup model
                model.onComplete.add(this.sendDataToServer)
                model.onAfterRenderPage.add(this.surveyPageChanged)
                model.onCurrentPageChanging.add((sender, options) => {
                    // Inject Sliding animation
                    if (!this.useAnimation) return
                    options.allowChanging = false
                    this.useAnimation = false
                    if (sender.currentPageNo < options.newCurrentPage.visibleIndex || sender.currentPageNo == 0) {
                        if (this.devMode) {
                            options.newCurrentPage = model.getPageByName(this.devSkipToPage)
                            this.devMode = false
                        }
                        this.animateSurveyPage("fadeIn", sender, options)
                    } else {
                        this.animateSurveyPage("fadeBack", sender, options)
                    }
                })
                model.onCurrentPageChanged.add((sender, options) => {
                    this.pageNeedsMods = true
                    this.pageComponent = null
                    this.pageValues = null
                    this.pageContent = null
                    let addedPageClass = sender.currentPage.pageClass? " "+sender.currentPage.pageClass.replace(" ", ""):""
                    this.pageClass = sender.currentPage.name + addedPageClass
                })
                model.onValueChanged.add((sender, options) => {
                    if (options.question.cssClasses.item == "sv_q_radiogroup") this.$sound('type')
                    console.log(this.survey.data)
                    let t = this.getElapsedTime()
                    if (this.timelog[this.survey.title] == undefined) this.timelog[this.survey.title] = {}
                    this.timelog[this.survey.title][options.question.page.name] = t
                })
                model.onCompleting.add((sender, options) => {
                    if (this.isCrossfaded) {
                        return
                    }
                    options.allowComplete = false
                    this.animateOutSurvey("fadeIn", sender, options)
                })
                // return model
                this.survey = model
            }).catch((err) => {
               console.log(err)
            })
        },
        setSurvey(title) {
            this.getSurvey(title)
        },
        keyboardNextBtnUpdate(str) {
            if (str == '') {
                this.setNextButton("Skip this") 
            } else {
                this.setNextButton("Next") 
            }
        },
        typed(val) {
            let str
            if (val == null || val == "") {
                str = ''
            } else {
                str = this.keyboardTarget.val()
                str += val
            }
            this.keyboardNextBtnUpdate(str)
            this.keyboardTarget.val(str)
            // Update the model
            let surveyEntry = this.survey.currentPage.questions[0].name
            if (surveyEntry) {
                this.survey.setValue(surveyEntry, str);
            }
            this.$sound('type')
        },
        backspace() {
            this.$sound('delete')
            let str = this.keyboardTarget.val()
            str = str.substring(0, str.length - 1)
            this.keyboardNextBtnUpdate(str)
            this.keyboardTarget.val(str)
            // Update the model
            let surveyEntry = this.survey.currentPage.questions[0].name
            if (surveyEntry) {
                this.survey.setValue(surveyEntry, str)
            }
        },
        sendDataToServer() {
            let forkSelection = this.survey.data.FORK
            let prevSurvey = this.survey.title
            // POST
            this.$postData(this.survey, this.authID, this.timelog[prevSurvey])

            // CLEAR AND STOP ANIMATIONS
            this.isCrossfaded = false
            this.useAnimation = false
            this.survey.clear(true, true)
            this.useAnimation = true

            // LOAD THE RIGHT PAGE HERE
            if (prevSurvey == "Introduction") {
                if (forkSelection) {
                    this.getSurvey(forkSelection)
                } else {
                    // Default
                    this.getSurvey("Physical")
                }
            } else if (prevSurvey == "Physical" || prevSurvey == "Mental" || prevSurvey == "Social") {
                this.getSurvey("Biometrics")
            } else if (prevSurvey == "Biometrics") {
                // DONE - TO THE REPORT!
                // But should print
                this.rebooted = true
                this.introSelection = null
                this.survey = null
                // WILL NEED LOGGING OUT
                this.$animateLEDS("passive", "#000000")
                // Let background fade to report color before changing the page
                setTimeout(() => {
                    this.$router.replace('/report')
                }, 2000)
            }
        },
        surveyPageChanged(survey, options) {
            let page = options.page
            page.htmlElement = $(options.htmlElement)
            if (!this.pageNeedsMods) return

            // Set NEXT button to default
            this.setNextButton("Next")

            // GENERIC PAGE COMPONENTS
            if (page.pageClass == "Vertical Slider") {
                // Apply the Slider Titles from the Question (in brackets)
                if (page.questions[0]) {
                    let slideTitles = [page.questions[0].upperChoice, page.questions[0].lowerChoice]
                    this.pageContent = slideTitles
                    this.pageComponent = "VerticalSlider"
                }
            } else if (page.pageClass == "Horizontal Slider") {
                let rows = []
                let columns = []
                for (let i = 0; i < page.questions[0].cells.rows.length; i++) {
                    const element = page.questions[0].cells.rows[i];
                    rows.push(page.questions[0].cells.rows[i].text)
                }
                for (let i = 0; i < page.questions[0].cells.columns.length; i++) {
                    const element = page.questions[0].cells.columns[i];
                    columns.push(page.questions[0].cells.columns[i].text)
                }
                let content = {
                    rows: rows,
                    values: columns
                }
                this.pageContent = content
                this.pageComponent = "HorizontalSlider"
                let hiddenForm = page.htmlElement.find('.drinks fieldset').remove()
            }

            // VALUES PAGE COMPONENT
            if (page.name == "pValues") {
                this.pageComponent = "ValuesExplorer"
                let hiddenForm = page.htmlElement.find('.sv_q_matrix_dropdown').remove()
            }
            // FORK PAGE RULES
            else if (page.name == "pFork") {
                this.survey.goNextPageAutomatic = true
            }
            // ENERGY PAGE COMPONENT
            /* 
            else if (page.name == "pEnergy") {
                if (page.questions[0]) {
                    let slideTitles = [page.questions[0].upperChoice, page.questions[0].lowerChoice]
                    //page.questions[0].title.split("{")[1].split("}")[0].replace(/['"]+/g, '').split(", ")
                    this.pageContent = slideTitles
                    this.pageComponent = "EnergySlider"
                }
                $('.sv_nav input.sv_next_btn')[0].style.opacity = 0;
                $('.sv_nav input.sv_next_btn')[0].style.pointerEvents = 'none'
                let hiddenForm = $(options.htmlElement).find('.energy input[type="range"]').remove()
            }
            */

            // BIOMETRICS - BREATHING
            else if (page.name == "pBreathing") {
                this.pageComponent = "Breathing";
                let hiddenForm = page.htmlElement.find('.oximeter').remove()
                $('.sv_nav input.sv_next_btn')[0].style.opacity = 0; // Hide next button
            }
            // BIOMETRICS - SCAN
            else if (page.name == "pScan") {
                this.pageComponent = "Scan";
                // Remove the form fields
                let hiddenForm = page.htmlElement.find('.scan').remove()
                $('.sv_nav input.sv_next_btn')[0].style.opacity = 0; // Hide next button
            }
            // BIOMETRICS - REPORT
            else if (page.name == "pBiometricsReport") {
                let ox = this.survey.data['oximeter']? this.survey.data['oximeter']: {hrv:"52.7",bp:"106/68"}
                let scan = this.survey.data['scan']? this.survey.data['scan']: {height:"5.8",width:"1.02",weight:"168"}
                let reportValues = {
                    oximeter: ox,
                    scan: scan
                }
                this.pageContent = reportValues
                this.pageComponent = "BiometricsReport"
            }

            // LOAD KEYBOARD AS NEEDED
            this.keyboardTarget = page.htmlElement.find('input[type="text"], input[type="number"]').not('.sv_q_radiogroup_other')
            this.keyboardTarget.attr('readonly', this.$isBooth)
            if (this.keyboardTarget[0]) {
                this.showKeyboard = true
                this.keyboardIsNumpad = (this.keyboardTarget[0].type == 'number')
                if (this.keyboardTarget[0].value == "") {
                    this.setNextButton("Skip this")
                }
            } else {
                this.showKeyboard = false
            }
            this.pageNeedsMods = false
        },
        setNextButton(string) {
            let nextBtn = $("#surveyContainer .sv_next_btn")
            if (nextBtn[0] != undefined) {
                nextBtn[0].style.opacity = 1
                nextBtn[0].style.pointerEvents = 'inherit'
                nextBtn.val(string)
            }
        },
        animateSurveyPage(animation, sender, options) {
            this.$sound('type')
            if (this.$refs.surveySlider) {
                this.$refs.surveySlider.style.pointerEvents = 'none'
            }
            let rangeO, rangeI
            switch (animation) {
                case "fadeIn":
                    rangeO = [0, -600]
                    rangeI = [300, 0]
                break;
                case "fadeBack":
                    rangeO = [0, 600]
                    rangeI = [-300, 0]
                break;
                default:
            }
            let fadeOut = this.$anime({
                targets: '#surveyContainer',
                translateX: rangeO,
                opacity: 0,
                easing: 'easeOutExpo',
                duration: 500,
                complete: (anim) => {
                    this.useAnimation = false
                    sender.currentPage = options.newCurrentPage
                    let fadeIn = this.$anime({
                        targets: '#surveyContainer',
                        translateX: rangeI,
                        opacity: 1,
                        easing: 'easeOutExpo',
                        duration: 800,
                        complete: (anim) => {
                            if (this.$refs.surveySlider) {
                                this.$refs.surveySlider.style.pointerEvents = 'auto'
                            }
                            this.useAnimation = true
                        }
                    });
                }
            });
        },
        animateOutSurvey(animation, sender, options) {
            this.$sound('chime')
            if (this.$refs.surveySlider) {
                this.$refs.surveySlider.style.pointerEvents = 'none'
            }
            let rangeO = [0, -600]
            let rangeI = [300, 0]
            let fadeOut = this.$anime({
                targets: '#surveyContainer',
                translateX: rangeO,
                opacity: 0,
                easing: 'easeInOutExpo',
                delay: 300,
                duration: 1000,
                complete: (anim) => {
                    console.log("Slid out, now complete")
                    // Complete survey
                    if (this.$refs.surveySlider) {
                        this.$refs.surveySlider.style.pointerEvents = 'auto'
                    }
                    // Send data, load next if applicable
                    this.isCrossfaded = true;
                    this.survey.allowComplete = true;
                    this.survey.doComplete()
                }
            })
        }
    },

    computed: {
        missingData() {
            return !this.mFeeling || !this.mColor
        },
        keyboardKeys() {
            let keys
            if (!this.keyboardIsNumpad) {
                keys = [
                    '1234567890{delete:delete}|qwertyuiop|asdfghjkl|{shift:goto:1}zxcvbnm,.|{space:space}',
                    '!@#$%^&*(){delete:delete}|QWERTYUIOP|ASDFGHJKL|{shift:goto:0}ZXCVBNM,.|{space:space}'
                ]
            } else {
                keys = [
                    '123|456|789|{clear:clear}0{delete:delete}'
                ]
            }
            return keys
        },
        surveyTitle() {
            return this.survey? this.survey.title: '';
        }
    },

    watch: {
        pageValues: function (val) {
            // console.log(val);
            if (val == null) return;
            let surveyEntry = this.survey.currentPage.questions[0].name
            if (surveyEntry) {
                this.survey.setValue(surveyEntry, val);
                // Certain pages must auto-advance
                if (this.survey.currentPage.name == "pBreathing" || this.survey.currentPage.name == "pScan") {
                    this.survey.nextPage()
                }
            } else {
                console.log("ERROR: No entry title for DB")
                console.log(val)
            }
        }
    },

    updated() {
    },

    created() {
    },

    destroyed() {
    },

    mounted() {
        let timeout = setTimeout(() => {
            let initSurvey = "Introduction"
            if (this.devMode) {
                initSurvey = this.devSkipToSurvey
            }
            this.getSurvey(initSurvey)
            // this.survey = this.getSurvey(initSurvey)
        }, 500)
    }
}
</script>

<style lang="scss">

@import "../styles/variables.scss";

#surveyContainer {
    overflow: hidden;
    .pIntro, .pIntroCh2  {
        .chapter {
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .title {
                margin-top: 10vh;
                font-family: "Walsheim";
                text-transform: uppercase;
                font-weight: 700;
                font-size: 2.9vw;
                letter-spacing: .1vw;
            }
            .name {
                font-weight: 700;
                font-size: 5.5vw;
                margin: 2vw;
                height: 55.8vh;
            }
            .description {
                font-weight: 400;
                margin-top: -.4vw;
                font-size: 5vw;
            }
        }
    }
    .pValues {
        .sv_qstn {
            width: 100%;
            border-right: 5vw solid transparent;
            border-left: 5vw solid transparent;
            box-sizing: border-box;
        }
        .sv_qstn > div > div {
            margin-top: 7vw;
            display: inherit;
            font-size: 3.5vw;
            opacity: .35;
        }
    }
    .pFork  {
        input.sv_complete_btn {
            display: none;
        }
        .sv_page_title span span {
            visibility: hidden;
            content:'';
            &:after {
                visibility: visible;
                content:'What next?';
                margin-left: -60px;
            }
        }
        .sv_q {
            .sv_q_title {
                height: 20vh;
            }
            
            .sv_q_radiogroup {
                *:focus {
                    outline: none;
                }
                height: 22vw;
                width: 60vw;
                box-sizing: content-box;
                margin: 1vw 0;
                background-color: transparent;
                color: $color-white;
                font-size: 5vw;
                line-height: 22vw;
                border-radius: 11vw;
                position: relative;
                padding: 0 8vw;
                .sv_q_radiogroup_label > span {
                    position: relative;
                    pointer-events: none;
                }
                input {
                    -webkit-appearance: none;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    background-color: blue;
                    border-radius: 11vw;
                    margin: 0;
                    pointer-events: all;
                    border: 3.5vw solid transparent;
                    background-repeat: no-repeat;
                    background-position: center right;
                    background-size: contain;
                    &[value='Physical'] {
                        background-color: $color-blue;
                        background-image: url(../assets/static/surveyIcoPhysicalHealth.png);
                    }
                    &[value='Mental'] {
                        background-color: $color-purple;
                        background-image: url(../assets/static/surveyIcoMentalHealth.png);
                    }
                    &[value='Social'] {
                        background-color: $color-orange;
                        background-image: url(../assets/static/surveyIcoSocialConnections.png);
                    }
                    transition: background-color .2s ease-in-out;
                }
                &.checked::before {
                    position: absolute;
                    margin-left: -4.2vw;
                    margin-top: -.5vw;
                    color: $color-white;
                    font-family: 'Open Sans', sans-serif;
                    font-weight: normal;
                    content: "\02143";
                    transform: rotate(40deg);
                }
                &.checked {
                    animation: tapDown .5s;
                }
                &.checked input {
                    background-color: $color-dark;
                    color: white;
                }
            }
        }
    }
    .pScanYesNo {
        .infographic {
            width: 20vw;
            height: 20vw;
            margin-left: auto;
            margin-right: auto;
            margin-top: 15vh;
            background-image: url(../assets/static/noCoat.svg);
            background-repeat: no-repeat;
            background-position: center center;
            background-size: contain;
        }
        .instruction {
            font-size: 3.5vw;
            color: $color-white;
        }
    }
    .pBreathing {
        .sv_next_btn {
            bottom: 0 !important;
        }
    }
    .pScan {
        .sv_q_title {
            margin-top: -5vh;
            padding-left: 4vw;
            padding-right: 4vw;
        }
    }
    .pBiometricsReport {
        .sv_q > div:first-child {
            height: 20vw;
        }
        .sv_q_description {
            color: $color-reportBlue;
            opacity: 1;
        }
        .sv_nav .sv_next_btn {
            bottom: 5vh;
        }
    }
    .pGoodJob {
        input.sv_next_btn, input.sv_complete_btn {
            bottom: 22.5vh;
        }
        .secondaryBtn {
            bottom: 15vh;
        }
    }
    .ddBedroomBehavior input.sv_complete_btn {
        bottom: 8vw;
    }
}

</style>